<template>
    <div class="card-box">
        <section class="title-box">
            <slot name="titleBox"></slot>
        </section>
        <el-divider></el-divider>
        <section class="info-box">
            <slot name="infoBox"></slot>
        </section>
        <el-divider></el-divider>
        <section class="custom-box">
            <slot name="customBox"></slot>
        </section>
        <section class="btn-box">
            <slot name="btnBox"></slot>
            <template v-if="btnList.length > 0">
                <div :style="{ textAlign: (btnList.length > 1 ? 'right' : 'center') }">
                    <el-button v-for="(item, index) in btnList" :key="index"
                        :type="item.type === 'confirm' ? 'primary' : ''" :style="item.style" @click="item.event">
                        {{ item.text }}</el-button>
                </div>
            </template>
        </section>
    </div>
</template>
<script>
export default {
  name: 'BLMCard',
  props: {
    btnList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.card-box {
    padding: 16px;
    .title-box {
        display: flex;
        align-items: center;
    }

    ::v-deep .el-divider--horizontal {
        margin: 14px 0
    }

    .custom-box {
        margin-bottom: 10px;
    }
}
</style>
